import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Popover from './Popover';

const ButtonWithPopover = ({
    ctaText, button, ctaFunc, ctaKey, placement,
}) => {
    const [open, setOpen] = useState(false);
    var anchorEl = useRef(null);

    // set button style based on button prop
    let btnClass;
    switch (button.style) {
        case 'primary':
            btnClass = 'btn--primary';
            break;
        case 'secondary':
            btnClass = 'btn--secondary';
            break;
        default:
            btnClass = 'btn--primary';
            break;
    }

    /**
     * Method to determine if the popup has previously been dismissed by the user
     */
    const ctaDismissed = () => {
        if (config.localStorage) {
            // eslint-disable-next-line angular/window-service
            return window.localStorage.getItem(
                `${ctaKey}_cta_dismissed`,
            ) || false;
        }
        return true;
    };

    const closePopUp = () => {
        setOpen(false);
        if (config.localStorage) {
            // eslint-disable-next-line angular/window-service
            window.localStorage.setItem(
                `${ctaKey}_cta_dismissed`,
                true,
            );
        }
    };

    useEffect(() => {
        if (!ctaDismissed()) {
            setOpen(true);
        }
    }, []);

    return (
        <div>
            <div ref={anchorEl} className="inline-block">
                <button type="button" role="button" className=" upgrade-cta__badge btn btn--ghost cursor-pointer" onClick={() => setOpen(!open)}><i className="fas fa-crown crown-icon pad-r-8px"></i>Upgrade</button>
            </div>
            <Popover open={open} anchorEl={anchorEl} closePopUp={closePopUp} placement={placement}>
                <p dangerouslySetInnerHTML={{ __html: ctaText }} className="upgrade-cta__text"/>
                <button className={`btn btn--small margin-t-8px width-auto ${btnClass}`} type="button" onClick={() => ctaFunc(ctaKey)}>{button.text}</button>
            </Popover>
        </div>
    );
};

ButtonWithPopover.propTypes = {
    ctaText: PropTypes.string.isRequired,
    ctaKey: PropTypes.string,
    button: PropTypes.object,
    ctaFunc: PropTypes.func,
    placement: PropTypes.string,
};

export default ButtonWithPopover;
